import React from 'react'
import { Box } from '@gousto-internal/citrus-react'

type ClickableBoxProps = {
  enabled: boolean
  onClick: () => void
  children: React.ReactNode
}

export const ClickableBox = ({ enabled, onClick, children }: ClickableBoxProps) => {
  if (!enabled) {
    return <>{children}</>
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick()
    }
  }

  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      style={{ cursor: 'pointer' }}
    >
      {children}
    </Box>
  )
}
